<template>
	<v-container class="body">
		<v-row align="center">
			<v-col>
        <p
          v-if="blok.subTitle"
          class="h3"
        >
          {{ blok.subTitle }}
        </p>
				<p
          v-if="blok.title"
          class="h1"
        >
          {{ blok.title }}
        </p>
			</v-col>
			<v-col>
				<ButtonLink
					v-if="$storyblok.isLink(blok.link)"
					:link="blok.link"
					:css-class="blok.image ? false : 'over-primary'"
				><slot v-if="blok.linkText">{{blok.linkText}}</slot></ButtonLink>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import ButtonLink from '~/components/util/ButtonLink';

	export default {
		name: 'BannerBody',
		props: ['blok'],
		components: {ButtonLink},
	}
</script>
